'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background: transparent;\n  border-width: 2px;\n  border-style: solid;\n  border-color: ', ';\n  box-shadow: none;\n  color: ', ';\n  &:focus:enabled,\n  &:hover:enabled {\n    background: ', ';\n    color: ', ';\n    transition: ', ' background,\n      ', ' color;\n  }\n'], ['\n  background: transparent;\n  border-width: 2px;\n  border-style: solid;\n  border-color: ', ';\n  box-shadow: none;\n  color: ', ';\n  &:focus:enabled,\n  &:hover:enabled {\n    background: ', ';\n    color: ', ';\n    transition: ', ' background,\n      ', ' color;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LargeButton = require('./LargeButton');

var _LargeButton2 = _interopRequireDefault(_LargeButton);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var OutlineButton = _LargeButton2.default.extend(_templateObject, function (props) {
  return (0, _theme.cx)(props.bg);
}, function (props) {
  return (0, _theme.cx)(props.bg);
}, function (props) {
  return (0, _theme.cx)(props.bg);
}, function (props) {
  return (0, _theme.cx)(props.color);
}, function (_ref) {
  var theme = _ref.theme;
  return theme.transition;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition;
});

OutlineButton.displayName = 'OutlineButton';

OutlineButton.defaultProps = {
  theme: _theme2.default,
  bg: 'primary',
  color: 'white',
  fontSize: 3,
  py: _theme2.default.space[3] - 2,
  px: _theme2.default.space[4] - 2,
  m: 0
};

exports.default = OutlineButton;